<div id="banner-factoring-nuevo" class="swiper-background d-lg-flex align-items-center pt-5 pt-lg-0">
    <div class="container">
        <div class="row">
            <div class="col-md-11 col-lg-8">
                <h1 class="h1-display primary-50 text-shadow-28 mb-3">Invierte en Adelanto de Facturas e impulsa la Economía Real</h1>
               <div class="d-none d-lg-block">
                <p class="p-display primary-50 d-flex align-items-center mb-2">
                    <span class="material-symbols-outlined me-2">check</span>
                    <span>Automatiza tus inversiones y disfruta del interés compuesto.</span>
                </p>
                
                <p class="p-display primary-50 d-flex align-items-center mb-2">
                    <span class="material-symbols-outlined me-2">check</span>
                    <span>Diversifica tu cartera en función de plazos y riesgos.</span>
                </p>
                
                <p class="p-display primary-50 d-flex align-items-center">
                    <span class="material-symbols-outlined me-2">check</span>
                    <span>Análisis y seguimiento exhaustivo de cada operación.</span>
                </p>
               </div>
               <div class="mt-lg-4">
                   <app-btn-link [linkId]="'btn-banner-invertir-factoring'" [linkTitle]="'Invertir'" [linkType]="'routerLink'" [linkStyle]="'secondary'" [linkUrl]="'oportunidades-inversion'"></app-btn-link>
                </div>
            </div>
        </div>
    </div>
</div>